<template>
  <div class="commercial-contract-view pa-4">

    <!-- 2. Grilla y Filtros gestionados con s-crud -->
    <s-crud
      ref="contractCrud"
      title="Contratos Comerciales"
      :config="config"
      :filter="filter"
      search-input
      singleRow
      add
      @add="openCreateModal"
      edit
      @edit="openEditModal"
      addNoFunction
      @rowSelected="onRowSelected($event)"
      @itemSelected="onItemSelected($event)"
      @doubleClick="openDetailModal($event)"
    >
      <!-- Slot de Filtros -->
      <template v-slot:filter>
        <v-container fluid class="pa-4">
          <v-row dense align="center">
            <v-col cols="12" sm="6" md="2">
              <s-text
                label="N° Contrato"
                v-model="filter.EccContractNumber"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <sselect-client-sap
                label="Cliente Comercial"
                v-model="filter.PrsCustomerID"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="6" md="2">
              <s-select-definition
                v-model="filter.TypeDestination"
                :def="1175"
                label="Destino"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="6" md="2">
              <s-select-campaign
                label="Campaña"
                v-model="filter.CmpID"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <s-text
                label="Producto o Línea"
                v-model="filter.ProductName"
                clearable
                placeholder="ej: Blueberry"
              />
            </v-col>

            <v-col cols="12" sm="6" md="2">
              <s-date
                label="Vigencia Desde"
                v-model="filter.DateBegin"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="6" md="2">
              <s-date
                label="Vigencia Hasta"
                v-model="filter.DateEnd"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="6" md="2">
              <s-select-definition
                v-model="filter.EccStatus"
                :def="1745"
                label="Estado"
                clearable
              />
            </v-col>
          </v-row>
        </v-container>
      </template>

      <!-- Slot de Opciones y Acciones de la Barra -->
      <template v-slot:options>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              small
              black
              v-bind="attrs"
              v-on="on"
              @click="openDetailModal(selectedContract)"
              :disabled="!selectedContract || !selectedContract.EccID"
            >
              <v-icon style="font-size:16px;">mdi-eye-outline</v-icon>
            </v-btn>
          </template>
          <span>Ver Detalle</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              small
              black
              v-bind="attrs"
              v-on="on"
              @click="downloadContractPdf(selectedContract)"
              :disabled="!selectedContract || !selectedContract.EccFileName"
            >
              <v-icon style="font-size:16px;">mdi-file-pdf-box</v-icon>
            </v-btn>
          </template>
          <span>Descargar PDF</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              small
              black
              v-bind="attrs"
              v-on="on"
              @click="cancelContract(selectedContract)"
              :disabled="!selectedContract || !selectedContract.EccID || selectedContract.EccStatus === 3"
            >
              <v-icon style="font-size:16px;">mdi-cancel</v-icon>
            </v-btn>
          </template>
          <span>Anular Contrato</span>
        </v-tooltip>
      </template>

      <!-- Formateo personalizado de celdas en la grilla -->
      <template v-slot:[`item.EccContractNumber`]="{ item }">
        <span class="font-weight-black grey--text text--darken-4">{{ item.EccContractNumber }}</span>
      </template>

      <template v-slot:[`item.TypeDestinationName`]="{ item }">
        <v-chip x-small class="font-weight-bold" :color="item.TypeDestination === 1 ? 'green lighten-5' : 'blue lighten-5'" :text-color="item.TypeDestination === 1 ? 'green darken-4' : 'blue darken-4'">
          {{ item.TypeDestinationName }}
        </v-chip>
      </template>

      <template v-slot:[`item.Vigencia`]="{ item }">
        <span class="caption grey--text text--darken-3">
          {{ item.EccValidityStartDate ? $fun.formatDateView(item.EccValidityStartDate) : '-' }} al {{ item.EccValidityEndDate ? $fun.formatDateView(item.EccValidityEndDate) : '-' }}
        </span>
      </template>

      <template v-slot:[`item.TotalAmount`]="{ item }">
        <span class="font-weight-black grey--text text--darken-4">
          {{ item.TotalAmount | formatCurrency }}
        </span>
      </template>

      <template v-slot:[`item.StatusName`]="{ item }">
        <v-chip
          x-small
          :color="getStatusColor(item.EccStatus)"
          text-color="white"
          class="font-weight-bold"
        >
          {{ item.StatusName }}
        </v-chip>
      </template>
    </s-crud>

    <!-- 3. Modales Desacoplados -->
    <commercial-contract-form-modal
      v-model="formModal.show"
      :contract-id="formModal.contractId"
      @saved="onContractSaved"
    />

    <commercial-contract-detail-modal
      v-model="detailModal.show"
      :contract-id="detailModal.contractId"
    />
  </div>
</template>

<script>
import SCrud from "@/components/Utils/SCrud.vue";
import SText from "@/components/Utils/SText.vue";
import SDate from "@/components/Utils/SDate.vue";
import SSelect from "@/components/Utils/SSelect.vue";
import SSelectDefinition from "@/components/Utils/SSelectDefinition.vue";
import SselectClientSap from "@/components/Sale/SselectClientSap.vue";
import SSelectCampaign from "@/components/Utils/SSelectCampaign.vue";
import CommercialContractFormModal from "./CommercialContractFormModal.vue";
import CommercialContractDetailModal from "./CommercialContractDetailModal.vue";
import _sCommercialContract from "@/services/ExternalTrade/CommercialContractService.js";
import _GenUploadFiles from "@/services/General/GenUploadFiles.js";

export default {
  name: "CommercialContract",
  components: {
    SCrud,
    SText,
    SDate,
    SSelect,
    SSelectDefinition,
    SselectClientSap,
    SSelectCampaign,
    CommercialContractFormModal,
    CommercialContractDetailModal,
  },
  filters: {
    formatCurrency(val) {
      if (val === null || val === undefined || isNaN(val)) return "0.00";
      return new Intl.NumberFormat("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val);
    },
  },
  data() {
    return {
      config: {
        model: {
          EccID: "ID",
          EccAgreementDate: "date",
          EccValidityStartDate: "date",
          EccValidityEndDate: "date",
        },
        service: _sCommercialContract,
        headers: [
          { text: "N° Contrato", value: "EccContractNumber" },
          { text: "Cliente", value: "EccCustomerName" },
          { text: "Comprador Legal", value: "EccBuyerLegalName" },
          { text: "Destino", value: "TypeDestinationName" },
          { text: "Vigencia", value: "Vigencia" },
          { text: "Moneda", value: "TypeCurrencyName" },
          { text: "Líneas", value: "TotalProducts" },
          { text: "Importe Contractual", value: "TotalAmount" },
          { text: "Estado", value: "StatusName" },
        ],
      },
      filter: {
        EccContractNumber: null,
        PrsCustomerID: null,
        TypeDestination: null,
        CmpID: null,
        ProductName: null,
        DateBegin: null,
        DateEnd: null,
        EccStatus: null,
      },
      selectedContract: null,
      formModal: {
        show: false,
        contractId: 0,
      },
      detailModal: {
        show: false,
        contractId: 0,
      },
    };
  },
  methods: {
    getStatusColor(status) {
      const map = { 1: "grey darken-1", 2: "primary", 3: "error", 4: "teal" };
      return map[status] || "grey";
    },
    onRowSelected(val) {
      if (Array.isArray(val)) {
        this.selectedContract = val.length > 0 ? val[0] : null;
      } else {
        this.selectedContract = val || null;
      }
    },
    onItemSelected(item) {
      this.selectedContract = item || null;
    },
    openCreateModal() {
      this.formModal.contractId = 0;
      this.formModal.show = true;
    },
    openEditModal(item) {
      const contract = item && item.EccID ? item : this.selectedContract;
      if (!contract || !contract.EccID) return;
      this.formModal.contractId = contract.EccID;
      this.formModal.show = true;
    },
    openDetailModal(item) {
      const contract = item && item.EccID ? item : this.selectedContract;
      if (!contract || !contract.EccID) return;
      this.detailModal.contractId = contract.EccID;
      this.detailModal.show = true;
    },
    onContractSaved() {
      if (this.$refs.contractCrud) {
        this.$refs.contractCrud.refresh();
      }
    },
    downloadContractPdf(item) {
      if (!item || !item.EccFileName) return;
      _GenUploadFiles.getFile("RutaAnexosSAP", item.EccFileName);
    },
    cancelContract(item) {
      if (!item || !item.EccID) return;

      this.$fun
        .alert(`¿Está seguro de anular el Contrato Comercial N° ${item.EccContractNumber}?`, "question")
        .then((r) => {
          if (r && r.value) {
            _sCommercialContract
              .cancel(item.EccID, this.$fun.getUserID())
              .then(() => {
                this.$fun.alert("Contrato comercial anulado correctamente.", "success");
                if (this.$refs.contractCrud) {
                  this.$refs.contractCrud.refresh();
                }
              })
              .catch((err) => {
                console.error("Error al anular contrato:", err);
                this.$fun.alert("Error al anular el contrato comercial.", "error");
              });
          }
        });
    },
  },
};
</script>

<style scoped>
.border-light {
  border: 1px solid #e2e8f0 !important;
}
</style>
